<template>
    <div>
		<div v-if="parseInt(tradingAccountList.totalLiveAccounts) == 1">
			<div class="CustomBlockWidth " > 
				<div class="card ">
				  <div class="card-body text-center">
					<img src="../../../../static/fxView/images/lost.svg" alt="no account found" class="mb-4" width="200">  
					<!-- Text -->
					<span v-if="get_user.step > 4">
						<p class="text-muted mb-3" >
						  {{$t('intTransMsz1')}} 
						</p>  
					</span>
					<p class="mb-3">{{$t('interTransMsz')}}</p>
					<router-link to="/create-live-account" class="prism_btn btn_sm lift">
					  {{$t('createLiveAccount')}} 
					</router-link>
				  </div>
				</div>
			</div>
		</div>
		<div  v-else-if="tradingAccountList.totalLiveAccounts  > 1">
			<div v-if="(parseInt(get_user.profile.gAuthenticatorEnabled) == 0 && authComponent && transaction_id != '' && !congModuleIntTransfer)">
				<app-twofa  :call_from="request_page"></app-twofa>
			</div>
			<div v-else>
				<div class="mainTitle text-center mt-4 mb-3"> 
					<h3 class="uppercase mb-4">{{$t('internalTransfer')}} </h3>
					<complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
				<message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
				</div> 
				<!--loader - message--->
				
				<!-------------------->
				<div class="CustomBlockWidth inMiddle-area whitebox p-4"> 
					<div class="justify-content-center"> 
						<!----------------------request form---------------------------------> 
						<div class="partcipate-fund" v-if="transaction_id == '' && !congModuleIntTransfer">
							<div v-if="conversionAmount">
								<p class="mb-3" >
									{{from_currency}} {{amount}} {{$t('interTransDeducted')}} {{account_id}} and  {{to_currency}} {{responseAmount}} {{$t('depostotradAcc')}} {{to_account_id}}
								</p>
								<div class="form-group text-center field-wrapper">
									<button class="prism_btn btn_sm" v-on:click="submitInternalTransferRequestOtp()">
										<span>{{$t('confToTransfer')}}</span>
									</button>
								</div>
								<div class="signupbtn mt-4 text-center">
									<a href="#" class="underline" @click="conversionAmount = false">{{$t('back')}} </a>
								</div>
							</div>
							<div v-else>
								<div class="form-group field-wrapper">
									<account-id></account-id>
								</div>
								<div class="form-group field-wrapper" v-if="fromBalance != 0 && CheckType(fromBalance)"><!-- fromBalance != '' -->
									<input placeholder=" " type="text" v-model="fromBalanceCurr"  v-validate="{ required: true }" name="fromBalanceCurr" class="float-field form-control"  :class="{ 'is-invalid': submitted && errors.has('fromBalanceCurr') }" ref="fromBalanceCurrInput" readonly />
									<label for="password" class="float-label">{{$t('freeMargin')}}</label>
								</div>
								<p v-if="account_id && !pageLoader && parseInt(fromBalance || 0) <= 0">{{$t('interTransSorryMsz')}} </p>
								<div v-if="fromBalance != '' && parseInt(fromBalance) > 0">
									<div class="form-group field-wrapper">
										<div class="customSelect mdb-select md-form float-field form-control" @click="selectToAccount = !selectToAccount" :class="(selectToAccount?'active' : '') || ((to_account_id == '' && submitted)?'is-invalid' : '')">
											<div class="SelectAcntList SelectAcntList2">
												<div class="d-flex align-items-center justify-content-between" v-if="to_account_id == ''">{{$t('transToAcc')}}</div>
												<div class="d-flex align-items-center justify-content-between" v-else>
													<span>
														<img :src="'../../../../static/fxView/images/'+platformIcon[to_platform]" class="mr-2" alt="Icon">
														{{to_account_id}} 
													</span>
													<small v-html="(parseInt(to_demo_live) == 1)? $t('live') : $t('demo') "></small>
												</div>
											</div>
											<ul class="scrollbar" >
												<li v-for="(list,key) in tradingAccountList.records" v-if="parseInt(list.demo_live) == 1 && list.account_id != account_id" @click="asignValueParentComponent(list)">
													<div class="aclist" > 
														<span>
															<img :src="'../../../../static/fxView/images/'+platformIcon[list.platform]" class="mr-2"  alt="Icon"> {{list.account_id}}  
														</span>
														<small v-html="(parseInt(list.demo_live) == 1)? $t('live') : $t('demo') "></small>
													</div>
												</li>
											</ul>
											<p class="error" v-if="(submitted && to_account_id == '')">{{$t('fieldReq')}}</p>
										</div>
									</div> 
									<div class="form-group field-wrapper" v-if="toBalance != ''">
										<input placeholder=" " type="text" v-model="toBalanceCurr"  v-validate="{ required: true }" name="toBalanceCurr" class="float-field form-control"  :class="{ 'is-invalid': submitted && errors.has('toBalanceCurr') }" ref="toBalanceCurrInput" readonly />
										<label for="password" class="float-label"> {{$t('currentBalance')}}</label>
									</div> 
									<div class="form-group field-wrapper" >
										<input type="text" placeholder=" " class="mdb-select md-form float-field form-control" v-model="amount" v-validate="'required'" name="amount"  :class="{ 'is-invalid': (submittedInternalOtp || submitted) && errors.has('amount') }" ref="amountInput">
										<label for="password" class="float-label">{{$t('pleseEnterAmount')}}  </label>
										<ul><li v-for="error in errors.collect('amount')">{{ error }}</li></ul>
									</div> 
									<div class="form-group text-center field-wrapper">
										<button class="prism_btn btn_sm" v-on:click="submitInternalTransferRequestOtp()">		
											<span v-if="!conversionAmount">{{$t('submit')}}</span>
											<span v-else>{{$t('confToTransfer')}}</span>
										</button>
									</div>
								</div>
								<div class="signupbtn mt-4 text-center" v-if="come_from_manage_page">
									<router-link :to="'/account-list'" class="underline">{{$t('backManageAccount')}} </router-link>
								</div>
							</div>
							<div class="clearfix"></div>
						</div>
						<!-------------------------------------------------------------------->
						<div class="partcipate-fund" v-if="transaction_id != '' && !congModuleIntTransfer">
							<div v-if="(parseInt(get_user.profile.gAuthenticatorEnabled) == 1)">
								<p class="mb-3 text-center">{{$t('googleAuth1')}} <strong>{{$t('googleAuth2')}}</strong> {{$t('googleAuth3')}}. </p>
								<div class="form-group field-wrapper">
									<input type="text" placeholder="000 000" class="mdb-select md-form form-control" v-model="otp" v-validate="{ required: true, max: 6,numeric : true }" name="otp"  :class="{ 'is-invalid': submittedInternalOtp && errors.has('otp') }" ref="otpInput">
									<ul><li v-for="error in errors.collect('otp')">{{ error }}</li></ul>
								</div> 
								<div class="form-group text-center field-wrapper">
									<button class="prism_btn btn_sm " v-on:click="submitInternalTransferCheckOtp()">{{$t('validate')}}  </button>
								</div>
								<div class="clearfix"></div>
								<div class="d-flex align-items-center justify-content-between border-top pt-3 mt-3"> 
									<div class="desc text-center">
										<p>{{$t('googleAuth4')}} <a v-on:click="resendLink()" href="#"><strong>{{$t('googleAuth5')}}</strong></a></p>
									</div>
								</div>
								<div class="clearfix"></div>
							</div>
							<div class="middleBox1" v-if="(parseInt(get_user.profile.gAuthenticatorEnabled) == 0 && !authComponent)">
								<div class="congratulations">
									<div class="logo_congrats">
										<img src="../../../../static/fxView/images/internal_transfer.svg" alt="Icon">
									</div>
									<div class="subtitle">
										<p class="mb-3">{{$t('dear')}} <strong class="green">{{get_user.username}}</strong>
											{{$t('googleAuth6')}} <strong>{{get_user.email}} . </strong> {{$t('intTransMsz2')}}
										</p>
										<a v-on:click="resendLink()" href="#" class="mb-3"><strong>{{$t('googleAuth7')}}</strong></a>
										
									</div>
								</div>
								<div class="clearfix"></div>
								<div class="d-flex align-items-center justify-content-between enble2fa border-top pt-3 mt-3">
									<div class="ico mr-3">
										<img src="../../../../static/fxView/images/google_auth.png" alt="2fa">
									</div>
									<div class="desc w-75">
										<h5 class="mb-2"><strong>{{$t('googleAuth8')}}</strong></h5>
										<p>{{$t('googleAuth9')}} <a v-on:click="authComponent = true" href="#"><strong>{{$t('googleAuth10')}}</strong></a></p>
									</div>
								</div>
							</div> 
						</div> 

						<div class="stepForm" v-if="congModuleIntTransfer">
							<div class="congratulations">
								<div class="logo_congrats">
									<img src="../../../../static/fxView/images/check.svg" alt="Icon">
								</div>
								<div class="subtitle">
									<h3>{{$t('congo')}}  <span class="green">{{get_user.username}}</span></h3>
									<p>{{$t('intTransMsz3')}} </p>
									<ul class="includeWdth">
										<li><strong>{{$t('fromTradId')}} </strong> {{res_data.account_id}}</li>
										<li><strong>{{$t('amount')}} </strong> {{parseFloat(res_data.amount).toFixed(2)}}</li>
										<li><strong>{{$t('toTradId')}} </strong>{{res_data.to_account_id}}</li>
										<li><strong>{{$t('transferAmount')}} </strong>{{parseFloat(res_data.trans_amount).toFixed(2)}}</li>
									</ul>
								</div>
							</div>
							<div class="signupbtn full-width submitButton w-100 mt-4 text-center">
								<router-link :to="'/account-list'" class="prism_btn btn_sm">{{$t('goBackMangeAcc')}} </router-link>
							</div> 
						</div>
						 
					</div>
				</div>
			</div>
		</div>
		<div v-else-if="tradingAccountList.totalLiveAccounts == 0">
			<div class="mainTitle  text-center my-3">
				<h3>{{$t('noTradingAccFound')}} </h3>
			</div>
			<no-trading-account></no-trading-account>
        </div>
		<div v-else class="text-center p-5 customLoader"> 
			<div class="loader"></div>  
            <h4>{{$t('plzWaitWhileProc')}}</h4>
        </div>
    </div>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    import twoFa from '../users/2FA'
    export default {
        name: 'Internal-transfer',
        mixins: [fxViewMixins],
        data() {
            return {
				pageName : this.$options.name,
                //============message and loader ===========
                response_msg : '',
                msg_type : '',
                pageLoader : false,
                //==========================================
                come_from_manage_page : false,

				//-----select account----
				selectAccount : false,
                account_id : '',
				act_account_id : '',
				demo_live : '',
				platform :'', 
				from_currency : '',
				//-----------------------
				selectToAccount : false,
                to_account_id : '',
				to_act_account_id : '',
				to_demo_live : '',
				to_platform :'', 
				to_currency : '',
				platformIcon : {'MT4' : 'platforn-icon-1.svg' , 'MT5' : 'platforn-icon-3.svg','ACT' : 'platforn-icon-2.svg'},
				
				
                amount : '',
                submitted : false,

                otp : '',
                submittedInternalOtp : false,
                transaction_id : '',
                congModuleIntTransfer : false,
                res_data : '',
                authComponent : false,
                request_page : 'internal-transfer',
				
				responseAmount : '',
				
				fromBalance : '',
				fromBalanceCurr : '',
				toBalance : '',
				toBalanceCurr : '',
				conversionAmount : false,
				isLoadingCount: 0,
            }
        },
        components: {
            appTwofa: twoFa
        },
        props:['accountId'],
        methods:{
        	CheckType(getvalue){
        		if(!isNaN(getvalue)){
        			return true
        		}
        	},
			asignValueParentComponent(list){
				this.to_account_id = list.account_id 
				this.to_act_account_id = list.act_account_id  
				this.to_demo_live = list.demo_live 
				this.to_platform = list.platform 
				this.to_currency = list.currency 
				this.tradingBonus('to') 
		    },
			tradingBonus(getData){
				if(this.account_id == this.to_account_id){
					this.response_msg = "suceessMsz25"
					this.msg_type = "error"
				}else{
					let input_json;
					this.isLoadingCount = this.isLoadingCount + 1;
					if(getData == 'from'){
						input_json = {
							'globalParams' : {
								'account_id' : this.account_id, 
								'act_account_id': this.act_account_id,  
								'demo_live' : this.demo_live , 
								'platform' : this.platform
							} ,'localParams' : {'parameter' : this, 'module' : getData, 'isLoadingCount': this.isLoadingCount}
						}
					}else{
						input_json = {
							'globalParams' : {
								'account_id' : this.to_account_id, 
								'act_account_id': this.to_act_account_id,  
								'demo_live' : this.to_demo_live , 
								'platform' : this.to_platform
							} ,'localParams' : {'parameter' : this, 'module' : getData}
						}
					}
					this._runGetAccountDetails(input_json)
				}
            },
            resendLink(){
                let input_json = {
                    'globalParams' : {
                        'trans_id' : this.transaction_id.toString()
                    } ,'localParams' : {'parameter' : this}
                }
                this._runResendEmailLinkAccount(input_json)
            },
            //================leverage===================================
            submitInternalTransferRequestOtp(){
				const _that = this
				_that.response_msg = '';
				_that.msg_type = '';
				if(this.conversionAmount){
					this.submitted = true;
					this.$validator.validate().then(valid => {
						if (valid) {
							if(parseFloat(_that.amount) > parseFloat(_that.fromBalance)){
								_that.response_msg = _that.$t('amountHigherThanMargin'),
								_that.msg_type = 'error'
							}else{
								let input_json={
									'globalParams' :{
										'act_account_id': _that.act_account_id, 
										'to_act_account_id': _that.to_act_account_id, 
										'account_id' : _that.account_id , 
										'to_account_id' : _that.to_account_id ,
										'currency' : _that.from_currency,
										'to_currency' : _that.to_currency,
										'amount' : _that.amount, 
										"operation" : "INTERNAL TRANSFER"
									},
									'localParams' :{ "parameter" : _that }
								}
								_that._runAccountPasswordRequestOtp(input_json)
							}
						}else{
							_that.handleValidationErrorAdvanced(_that.errors)
						}
					});
				}else{
					this.submitted = true;
					this.$validator.validate().then(valid => {
						if (valid) {
							if(parseFloat(this.amount) > parseFloat(this.fromBalance)){
								_that.response_msg = _that.$t('amountHigherThanMargin'),
								_that.msg_type = 'error'
							}else{
								let input_json={
									'globalParams' :{
										from_currency : this.from_currency, 
										to_currency : this.to_currency,
										amount : this.amount
									},
									'localParams' :{ "parameter" : this }
								}
								this._runAmountConversionApi(input_json)
							}
						}
					});
					
				}
            },
            submitInternalTransferCheckOtp(){
                const _that = this
                this.submittedInternalOtp = true;
                this.$validator.validate().then(valid => {
                    if (valid) {
                        let input_json={
                            'globalParams' :{
                                'google_token' : _that.otp.toString() ,
                                'trans_id' : _that.transaction_id.toString()
                            },
                            'localParams' :{ "parameter" : _that }
                        }
                        _that._runInternalTransferCheckOtp(input_json)
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
            },
            reset(){
				//-----select account----
				this.selectAccount =  false
                this.account_id =  ''
				this.act_account_id =  ''
				this.demo_live =  ''
				this.platform = '' 
				this.from_currency =  ''
				//-----------------------
				this.selectToAccount =  false
                this.to_account_id =  ''
				this.to_act_account_id =  ''
				this.to_demo_live =  ''
				this.to_platform = '' 
				this.to_currency =  ''
                this.amount = ''
                this.submitted = false
            }
        },
        created(){
	     if(this.$route.params.account_id){
                this.come_from_manage_page = true
                this.account_id = this.$route.params.account_id
				this.act_account_id = this.$route.params.act_account_id
				this.demo_live = this.$route.params.demo_live
				this.platform = this.$route.params.platform 
				this.from_currency = this.$route.params.from_currency
				this.tradingBonus('from')
            }
			this.isLoadingCount = this.isLoadingCount + 1;
			this._runGetTradingAccountList({'globalParams' : {} ,'localParams' : {'parameter' : this, 'isLoadingCount': this.isLoadingCount}})
        },
		mounted() { 
			const _that = this
            $(document).on("click", function(event){
				if(!$(event.target).closest('.SelectAcntList2').length){
                    _that.selectToAccount = false
                }
            });
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/manageAccounts/internal_transfer.vue